import { render, staticRenderFns } from "./patrolImprove.vue?vue&type=template&id=5b3f30c1"
import script from "./patrolImprove.vue?vue&type=script&lang=js"
export * from "./patrolImprove.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5b3f30c1')) {
      api.createRecord('5b3f30c1', component.options)
    } else {
      api.reload('5b3f30c1', component.options)
    }
    module.hot.accept("./patrolImprove.vue?vue&type=template&id=5b3f30c1", function () {
      api.rerender('5b3f30c1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sai/patrol/patrolImprove.vue"
export default component.exports